import React, { lazy, Suspense } from 'react';
const Home = lazy(() => import("@/pages/Home/Home"));
const WebAuth = lazy(() => import("@/pages/webAuth")); // 网页授权
const HelperAuth = lazy(() => import("@/pages/helperAuth")); // 小助手授权
const AccountInfo = lazy(() => import("@/pages/webAuth/info/index")); // 授权页面
const AccountGroup = lazy(() => import("@/pages/accountGroup")); // 账号组
const TaskList = lazy(() => import("@/pages/taskList")); // 任务列表
const TaskInfo = lazy(() => import("@/pages/taskList/info/index")); // 任务详情
const VideoList = lazy(() => import("@/pages/videoList")); // 视频
const Merchant = lazy(() => import("@/pages/merchant")); // 商家
const PublishWorks = lazy(() => import("@/pages/publishWorks"))// 发布作品
const Authorization = lazy(() => import("@/pages/authorization")); // 授权
const Authcallback = lazy(() => import("@/pages/authcallback")) // 快手授权回调
const TiktokAuth = lazy(() => import("@/pages/tiktokAuth")) // tiktok授权回调
const GenerateCode = lazy(() => import("@/pages/generateCode")) // 生成二维码
// const ClientMandate = lazy(() => import("@/pages/clientMandate")) // 生成二维码
const MyCode = lazy(() => import("@/pages/myCode")) // 我的二维码
const MessageManage = lazy(() => import("@/pages/messageManage/MessageManage.tsx")) //私信管理
const DouyinAuth = lazy(() => import("@/pages/douyinAuth")) // 抖音授权
const CommentManage = lazy(() => import("@/pages/commentManage/CommentManage.tsx"))
const DraftList = lazy(() => import("@/pages/draftList/DraftList"))
const CollectionManage = lazy(() => import("@/pages/collectionManage/CollectionManage.tsx"))
const IntelligentReply = lazy(() => import("@/pages/IntelligentReply/IntelligentReply.tsx"))
const IntelligentReplyCreate = lazy(() => import("@/pages/IntelligentReply/components/StrategyList/StrategyForm"))
const ToolMount = lazy(() => import("@/pages/ToolMount/ToolMount.tsx"))
const VideoForm = lazy(() => import("@/pages/videoList/components/VideoForm/VideoForm.tsx"))
import Layout from "@/pages/Layout/Layout";
import LoadingDom from '@/components/LoadingDom/index'
import Log from '@/pages/log';
import Login from "@/pages/login/index.tsx"
import { Navigate } from 'react-router-dom';
export const routes = [
    {
        path: "/",
        element: <Navigate to="/matrix" />,
    },
    {
        path: '/matrix',
        element: <Layout></Layout>,
        children: [
            {
                index: true,
                element: <Suspense fallback={<LoadingDom isLoading><div style={{ width: "100%", height: "100%" }}></div></LoadingDom>}><Home/></Suspense>,
                showTab: false
            },
            {
                path: 'webAuth',
                element: <Suspense><WebAuth /></Suspense>,
                showTab: false
            },
            {
                path: 'helperAuth',
                element: <Suspense><HelperAuth /></Suspense>,
                showTab: false
            },
            {
                path: 'webAuth/info', // 网页授权详情
                element: <Suspense><AccountInfo /></Suspense>,
                showTab: false
            },
            {
                path: 'helperAuth/info', // 小助手授权详情
                element: <Suspense><AccountInfo /></Suspense>,
                showTab: false
            },
            {
                path: 'accountGroup',
                element: <Suspense><AccountGroup /></Suspense>,
                showTab: true
            },
            {
                path: 'task',
                element: <Suspense><TaskList /></Suspense>,
                showTab: false
            },
            {
                path: 'task-detail',
                element: <Suspense><PublishWorks /></Suspense>,
            },
            {
                path: "task/info", // 任务详情
                element: <Suspense><TaskInfo /></Suspense>,
                showTab: false
            },
            {
                path: "videoList",
                element: <Suspense><VideoList /></Suspense>,
                showTab: true
            },
            {
                path: "merchant",
                element: <Suspense><Merchant /></Suspense>,
                showTab: false
            },
            {
                path: "publish-works",
                element: <Suspense><PublishWorks /></Suspense>,
                showTab: false
            },
            {
                path: "authorization",
                element: <Suspense><Authorization /></Suspense>,
                showTab: false
            },
            {
                path: "authorization/:platform",
                element: <Suspense><Authorization /></Suspense>,
                showTab: false
            },
            {
                path: "generateCode",
                element: <Suspense><GenerateCode /></Suspense>,
                showTab: false
            },
            {
                path: 'myCode',
                element: <Suspense><MyCode /></Suspense>,
                showTab: false
            },
            // {
            //     path: 'mandate',
            //     element: <Suspense><ClientMandate /></Suspense>,
            //     showTab: false
            // },
            {
                path: 'message',
                element: <Suspense><MessageManage /></Suspense>,
                showTab: false,
            },
            {
                path: 'comment',
                element: <Suspense><CommentManage /></Suspense>,
                showTab: false,
            },
            {
                path: 'intelligent-reply',
                element: <Suspense><IntelligentReply /></Suspense>,
                showTab: false,
            },
            {
                path: 'intelligent-reply-create',
                element: <Suspense><IntelligentReplyCreate /></Suspense>,
                showTab: false,
            },
            {
                path: 'draft',
                element: <Suspense><DraftList /></Suspense>,
                showTab: false,
            },
            {
                path: "log", // 小助手授权详情
                element: (
                    <Suspense>
                        <Log />
                    </Suspense>
                ),
                showTab: false,
            },
            {
                path: 'collection',
                element: <Suspense><CollectionManage/></Suspense>
            },
            {
                path: 'toolMount',
                element: <Suspense><ToolMount/></Suspense>
            },
            {
                path: 'video-edit',
                element: <Suspense><VideoForm/></Suspense>
            }
        ],
    },
    {
        path: '/matrix/authcallback',
        element: <Suspense><Authcallback /></Suspense>
    },
    {
        path: '/matrix/douyinAuth',
        element: <Suspense><DouyinAuth /></Suspense>,
    },
    {
        path: '/matrix/tiktok-callback',
        element: <Suspense><TiktokAuth /></Suspense>
    },
    {
        path: '/login',
        element: <Login />
    }
];
